import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { COMPANIES, OPPORTUNITIES, CONTACTS } from 'constants/Entities';
import MergeFuzzySearch from './components/fields/fuzzysearch';
import Literal from 'components/Literal'; // FIXME Please use getLiteral here

const propTypes = {
    data: PropTypes.object,
    id2: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    entityType: PropTypes.object,
    schema: PropTypes.array,
    dataEntity: PropTypes.object,
    onSelectEntity: PropTypes.func,
    onChangeAdvancedSearch: PropTypes.func,
};

class EntityMergeHeader extends PureComponent {
    state = {};

    render() {
        const {
            data,
            id2,
            entityType,
            schema,
            dataEntity,
            onSelectEntityForFuzzy,
            onChangeAdvancedSearch,
            literals,
        } = this.props;

        let name = '';
        let name2 = '';

        data &&
            schema.map((section) => {
                section.tabFields.map((field) => {
                    if (field.title) {
                        name = field.id;
                        name2 = field.id;
                    }
                });
            });

        name = data && data[name] ? data[name] : '';
        name2 = dataEntity && dataEntity[name2] ? dataEntity[name2] : '';

        const entity1Name = <Literal literal={literals.labelEntity1Name} />;
        const entity2Name = <Literal literal={literals.labelEntity2Name} />;
        let advancedSearch = null;

        if (onChangeAdvancedSearch && !name2) {
            advancedSearch = (
                <div
                    className="fm-entity-merge__advanced-button"
                    onClick={() => onChangeAdvancedSearch(true)}
                >
                    <Literal literal={literals.labelSuggestDuplicates} />
                </div>
            );
        }

        let showSecondFuzzy = (!id2 && !dataEntity) || (id2 && !dataEntity);

        const secondColumnStyle = ['fm-entity-merge__header-left'];
        if (id2) secondColumnStyle.push('with-padding');

        let dataId = data.id || data.Id;
        if (dataId && dataId.hasOwnProperty('value')) {
            dataId = dataId.value;
        }

        return (
            <div className="fm-entity-merge__header">
                <div className={secondColumnStyle.join(' ')}>
                    <div>{entity1Name}</div>
                    <div className="fm-entity-merge__header-subtitle">{name}</div>
                </div>
                <div className="fm-entity-merge__header-right">
                    <div>{entity2Name}</div>
                    {showSecondFuzzy ? (
                        <Fragment>
                            <MergeFuzzySearch
                                entity={entityType.entity}
                                onSelectItem={onSelectEntityForFuzzy}
                                ignore={data && dataId}
                            />
                            {advancedSearch}
                        </Fragment>
                    ) : (
                        <div className="fm-entity-merge__header-subtitle">{name2}</div>
                    )}
                </div>
            </div>
        );
    }
}

EntityMergeHeader.propTypes = propTypes;

export default EntityMergeHeader;
